import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['form']

  connect() {
    this.previewImages = {
      logo: null,
      cover: null
    }

    // Listen for image changes
    this.element.addEventListener('asset:image-changed', this.handleImageChange.bind(this))
  }

  handleImageChange(event) {
    const { kind, src, hasFile } = event.detail
    this.previewImages[kind] = hasFile ? src : null
    this.updatePreview()
  }

  updateLandingPageType(_event) {
    const form = this.formTarget
    const formData = new FormData(form)

    formData.append('preview_update', 'true')

    if (this.previewImages.logo) {
      formData.append('preview_logo_data_url', this.previewImages.logo)
    }
    if (this.previewImages.cover) {
      formData.append('preview_cover_data_url', this.previewImages.cover)
    }

    fetch(form.action + '/update_preview', {
      method: 'PATCH',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    }).catch(error => {
      console.warn('Preview update failed:', error)
    })
  }

  updatePreview(_event) {
    clearTimeout(this.previewTimeout)
    this.previewTimeout = setTimeout(() => {
      const form = this.formTarget
      const formData = new FormData(form)
      formData.append('preview_update', 'true')

      if (this.previewImages.logo) {
        formData.append('preview_logo_data_url', this.previewImages.logo)
      }
      if (this.previewImages.cover) {
        formData.append('preview_cover_data_url', this.previewImages.cover)
      }

      fetch(form.action + '/update_preview', {
        method: 'PATCH',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: formData
      }).then(response => {
        if (response.ok) {
          return response.text()
        }
      }).then(html => {
        if (html) {
          Turbo.renderStreamMessage(html)
        }
      }).catch(error => {
        console.warn('Preview update failed:', error)
      })
    }, 300)
  }

  toggleField(event) {
    const fieldType = event.target.dataset.fieldType
    const form = this.formTarget
    const formData = new FormData(form)

    // Add the field_type parameter
    formData.append('field_type', fieldType)

    if (this.previewImages.logo) {
      formData.append('preview_logo_data_url', this.previewImages.logo)
    }
    if (this.previewImages.cover) {
      formData.append('preview_cover_data_url', this.previewImages.cover)
    }

    fetch(form.action + '/toggle_field', {
      method: 'PATCH',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: formData
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
    }).then(html => {
      if (html) {
        Turbo.renderStreamMessage(html)
      }
    }).catch(error => {
      console.warn('Toggle field failed:', error)
    })
  }
}
